/**
 * TOOLTIP TEXT THAT HAS TO CHANGE WITH THE PRODUCT.
 *
 * <h2>⚠ TWO SURVIVING ICONS ADVERTISED ASTROLOGY ON integralDelta</h2>
 *
 * The product deny list removes the eight ephemeris studies, the four designers, the Visual
 * Universe, the Φ scan and the astro catalog — so the obvious conclusion is that nothing
 * astrological is left on that toolbar. It is not quite true of the WORDS. RSI and MACD are
 * deliberately kept on every product, and both of their tooltips ended:
 *
 *     "...to combine this technical study with other astro-studies if desired"
 *
 * A customer of a product sold as strict zero astrology hovers an indicator and is told about
 * astro-studies. The icons were gated and the sentences were not, which is the same shape as the
 * header brand: the gate was product-aware and a string beside it was a constant.
 *
 * <h2>Why a rewrite rather than a second tooltip per icon</h2>
 *
 * The ICONS array is module-level data and a tooltip is read at render, so the product is not in
 * scope where the strings are written. Threading it in would mean every entry becoming a function
 * of product — fifty-six closures to make two of them vary. This maps the two sentences that
 * actually differ, by their exact current text, and returns everything else UNTOUCHED by identity.
 *
 * <p>⚠ KEYED ON THE FULL STRING, which is brittle ON PURPOSE. An edit to either tooltip stops it
 * matching, and `productTooltips.test.js` fails rather than letting the astro wording silently
 * return to the integralDelta toolbar. A substring rule would quietly cover a reworded sentence
 * and would also catch tooltips nobody checked.
 */

import { INTEGRALDELTA } from '../config/productTarget';

/** The tail both sentences share — the clause that names astrology. */
const ASTRO_TAIL = ' to combine this technical study with other astro-studies if desired';
/** Its replacement: the same invitation, without the noun. */
const NEUTRAL_TAIL = ' to combine it with the other studies on the chart';

const RSI_HEAD = 'Toggle RSI overlay in the Volume Panel';
const MACD_HEAD = 'Toggle standard MACD overlay in the Volume Panel';

/**
 * The exact astro-flavoured sentences, and their neutral replacements.
 *
 * <p>COMPUTED KEYS, because the originals are longer than the line limit and an object key cannot
 * be a concatenation without them. Composed from the shared head/tail constants rather than
 * retyped, so the two halves of each pair cannot drift apart.
 */
export const TOOLTIP_REWRITES = Object.freeze({
  [INTEGRALDELTA]: Object.freeze({
    [RSI_HEAD + ASTRO_TAIL]: RSI_HEAD + NEUTRAL_TAIL,
    [MACD_HEAD + ASTRO_TAIL]: MACD_HEAD + NEUTRAL_TAIL,
  }),
});

/**
 * The tooltip to show for {@code text} on {@code product}.
 *
 * <p>Returns the input BY IDENTITY when nothing applies, so this is safe to wrap every icon in —
 * and an unknown product changes nothing, which is the right default for a cosmetic rewrite.
 */
export const tooltipForProduct = (text, product) => {
  if (typeof text !== 'string' || !text) return text;
  const table = TOOLTIP_REWRITES[product];
  return (table && table[text]) || text;
};

export default tooltipForProduct;
